import * as React from "react";

function Feedback(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z"
        fill="#F3F4F6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 20.25a8.25 8.25 0 100-16.5 8.25 8.25 0 000 16.5z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.25 12a8.25 8.25 0 11-16.5 0 8.25 8.25 0 0116.5 0zm-9.137-2.793a1.5 1.5 0 012.26 1.295v.001c0 .352-.274.719-.791 1.064a4.54 4.54 0 01-.935.47l-.012.005a.75.75 0 00.475 1.423l-.237-.712.238.712h.001l.003-.002.008-.003.026-.009a5.873 5.873 0 00.38-.153c.237-.105.558-.265.885-.483.607-.405 1.458-1.163 1.459-2.311a3 3 0 00-5.83-1 .75.75 0 001.415.498 1.5 1.5 0 01.655-.795zm.82 5.796a.75.75 0 100 1.5h.007a.75.75 0 000-1.5h-.007z"
        fill="#076698"
      />
    </svg>
  );
}

export default Feedback;
